import React, { Fragment } from 'react';
import { useAuth0 } from "./auth";

import Menu from './navigation/menu';
import Drawer from './navigation/drawer';
import MobileMenu from './navigation/mobileMenu';
import ProfileMenu from './navigation/profileMenu';
import SuperUserToolbar from './superUserToolbar';
import LoadingIndicator from '../common/loadingIndicator';
import MakrwatchLogo from '../common/components/makrwatchLogo';
import {isSU, isServiceMember, isPaymentMember} from '../common/authHelper';
import '../styles/menu.scss';


const Main = ({children}) => {

    const { loginWithRedirect, isAuthenticated, loading, user, logout } = useAuth0();

    if(loading) {
        return <LoadingIndicator/>;
    }

    if(!isAuthenticated) {
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.has('error') && urlParams.has('error_description')) {
            return (
                <div>
                    {urlParams.get('error_description')}
                    <div onClick={() => logout({ returnTo: window.location.origin })} style={ {cursor: 'pointer', color: 'blue'} }>Log out</div>
                </div>
            );
        } else {
            loginWithRedirect({});
            return null;
        }
    }

    let classContainer = 'app-container';
    let superUserComponent = null;
    if(isSU(user) || isServiceMember(user) || isPaymentMember(user)) {
        classContainer += ' super-user-app-container';
        superUserComponent = (<div className="top-container"><SuperUserToolbar /></div>);
    }

    return (
        <Fragment>
            <div className={classContainer}>
                {superUserComponent}
                <div className="mobile-menu-container">
                    <MobileMenu />
                </div>
                <div className="left-container">
                    <div className="logo-container">
                        <MakrwatchLogo />
                    </div>
                    <div className="menu-container">
                        <Menu />
                    </div>
                    <ProfileMenu />
                </div>
                <div className="main-container">
                    {children}
                </div>
            </div>
            <div className="drawer-container">
                <Drawer />
            </div>
        </Fragment>
    );
};

export default Main;
